import { render, staticRenderFns } from "./formManagement.vue?vue&type=template&id=cd7dc242"
import script from "./formManagement.vue?vue&type=script&lang=js"
export * from "./formManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports